import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import Spinner from "@/components/ui/spinner";
import useLicenseCheck from "@/hooks/useLicenseCheck";
import { Outlet } from "react-router-dom";
import NoLicenseScreen from "./license/NoLicenseScreen";

const CheckLicense = () => {
    const { hasValidLicense, isLoading: isLicenseLoading } = useLicenseCheck();

    if (isLicenseLoading) {
        return (
            <div className="relative flex h-screen w-full items-center justify-center">
                <Spinner />
                <div className="absolute inset-x-0 bottom-8 flex justify-center">
                    <LogoutEscapeLink variant="pillLight" />
                </div>
            </div>
        );
    }

    if (!hasValidLicense) {
        return <NoLicenseScreen />;
    }

    return <Outlet />;
};

export default CheckLicense;
